// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","396":"73b1733b","453":"03346f77","455":"725e4630","977":"240addac"}[chunkId] + ".chunk.js";
};